import {
  ChangeDetectionStrategy,
  Component,
  input,
  linkedSignal,
  signal,
} from '@angular/core';
import { SessionService } from '@core/services/session.service';
import { SvgIconComponent } from 'angular-svg-icon';
import {
  NgpTabset,
  NgpTabList,
  NgpTabButton,
  NgpTabPanel,
} from 'ng-primitives/tabs';

import { ReactiveFormsModule } from '@angular/forms';
import { UserGamesHistoryComponent } from '../user-history/user-games-history/user-games-history.component';
import { UserTransactionsHistoryComponent } from '../user-history/user-transactions-history/user-transactions-history.component';
import { MyProfileComponent } from '../my-profile/my-profile.component';
import { UserSelfExclusionComponent } from '../user-self-exclusion/user-self-exclusion.component';

type TabVariant =
  | 'profile'
  | 'games-history'
  | 'transactions-history'
  | 'self-exclusion';
interface TabItem {
  label: string;
  icon: string;
  key: TabVariant;
}

@Component({
  selector: 'app-my-profile-modal',
  imports: [
    SvgIconComponent,
    NgpTabset,
    NgpTabList,
    NgpTabButton,
    NgpTabPanel,
    ReactiveFormsModule,
    MyProfileComponent,
    UserGamesHistoryComponent,
    UserTransactionsHistoryComponent,
    UserSelfExclusionComponent,
  ],
  templateUrl: './my-profile-modal.component.html',
  styleUrl: './my-profile-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    class: 'modal-container flex',
  },
})
export class MyProfileModalComponent {
  tab = input<TabVariant>('profile');
  readonly selectedTab = linkedSignal<TabVariant>(() => this.tab());

  tabs: TabItem[] = [
    {
      label: 'Profile',
      icon: 'assets/icons/shared/profile.svg',
      key: 'profile',
    },
    {
      label: 'Games History',
      icon: 'assets/icons/shared/clock.svg',
      key: 'games-history',
    },
    {
      label: 'Transactions History',
      icon: 'assets/icons/core/price.svg',
      key: 'transactions-history',
    },
    {
      label: 'Self exclusion',
      icon: 'assets/icons/shared/user-cross.svg',
      key: 'self-exclusion',
    },
  ];

  constructor(public sessionService: SessionService) {}
}
